import { createRoot } from 'react-dom/client';
import { getStringAttribute } from '@repo/widget-utils/attributes/attribute-helper';
import BilberryCustomElement from 'src/widgets/BilberryCustomElement';
import { WidgetWrapper } from 'src/widgets/WidgetWrapper';
import PackageItinerary from './PackageItinerary';

class PackageItineraryWidget extends BilberryCustomElement {
    protected renderWidget(): void {
        const packageId = getStringAttribute(this, 'package-id', false) ?? '';

        createRoot(this._mountPoint).render(
            <WidgetWrapper
                mountPoint={this._mountPoint}
                popoverMountPoint={this._popoverMountPoint}
                shadowRoot={this._shadowRoot}
            >
                <PackageItinerary id={packageId} />
            </WidgetWrapper>,
        );
    }
}

export default function defineCustomElement() {
    customElements.define('bilberry-package-itinerary', PackageItineraryWidget);
}
